import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import {callAPIAndRemoveGiftcard} from '../../../actions/paymentActions/giftcard/giftcardActions';
import Translation from '../../../lang/Translation';
import Spacing from '../../../style-helper/Spacing';
import CheckoutOverlay from '../CheckoutOverlay';

const useStyles = createUseStyles({
  removeGiftcardOverlay: {
    fontSize: 17,
  },
  buttonContainer: {
    marginTop: Spacing.quad,
  },
});

export function RemoveGiftcardOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      autosize
      className={classes.removeGiftcardOverlay}
      data-test="RemoveGiftcardOverlay"
      isCollection
      stickyHeader
    >
      <h3><Translation>remove.gift.card</Translation></h3>
      <Translation>gift.card.remove.content</Translation>
      <div
        className={classes.buttonContainer}
        data-test="RemoveGiftcardOverlay__buttonContainer"
      >
        <Button
          id="RemoveGiftcardOverlay__closeButton"
          className="RemoveGiftcardOverlay__closeButton"
          primary
          fullWidth
          onClick={() => {
            props.callAPIAndRemoveGiftcard(props.cardUUID);
            props.hideOverlay();
          }}
        >
          <Translation>gift.card.confirm.remove</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

RemoveGiftcardOverlay.propTypes = {
  callAPIAndRemoveGiftcard: PropTypes.func.isRequired,
  hideOverlay: PropTypes.func.isRequired,
  cardUUID: PropTypes.string.isRequired,
};

export default connect(
  null,
  {callAPIAndRemoveGiftcard, hideOverlay},
)(RemoveGiftcardOverlay);
